import React, { ReactNode } from 'react';
import { Box, Button, Typography } from '@mui/material';

interface Props {
  title: string;
  onReset?: () => void;
  isReadOnly?: boolean;
  children: ReactNode;
}

export const FormSection = ({ title, onReset, isReadOnly = false, children }: Props) => (
  <Box
    sx={{
      display: 'flex',
      borderRadius: '4px',
      flexDirection: 'column',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 16px',
        borderRadius: '4px 4px 0 0',
        backgroundColor: '#E3F2FD',
      }}
    >
      <Typography variant="subtitle1" component="span" fontWeight={600}>
        {title}
      </Typography>

      {onReset && !isReadOnly && (
        <Button size="small" variant="contained" onClick={onReset}>
          Reset
        </Button>
      )}
    </Box>

    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '16px' }}>{children}</Box>
  </Box>
);
